import React from "react";
import SignIn from "./signIn";

const Login = () => {
  return (
    <>
      <div>
        <SignIn />
      </div>
    </>
  );
};

export default Login;
